import styled from 'styled-components';
import { cvBreakpoint768 } from '@carvana/theme';

export const TitleWrapper = styled.div`
  ${props => props.alignStart
    ? 'align-self: flex-start;'
    : `
      margin-left: auto;
      margin-right: auto;
    `
  }
  ${props => props.maxWidth && `max-width: ${props.maxWidth};`}
  ${props => props.marginBottom >= 0
  ? `margin-bottom: ${props.marginBottom}px;`
  : `margin-bottom: 40px;`
  }
`;

export const TitleNext = styled.h1`
  color: ${props => props.theme.carvana.blue.dark};
  font-weight: bold;
  text-align: left;
  text-transform: ${props => props.uppercase && 'uppercase'};
  ${props => props.fontSize >= 0
    ? `font-size: ${props.fontSize}px;`
    : `font-size: 28px;`
  }

  ${TitleWrapper} > & {
    margin-bottom: 0;
  }
`;

export const SubtitleNext = styled.p`
  color: ${props => props.theme.carvana.gray.dark};
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 40px;
  max-width: 680px;
  text-align: left;

  @media (min-width: ${cvBreakpoint768}px) {
    font-size: initial;
  }

  ${TitleWrapper} > & {
    margin-bottom: 0;
  }
`;
